import { render, staticRenderFns } from "./AppSublayerHeader.vue?vue&type=template&id=ef48a074&scoped=true&lang=pug&"
import script from "./AppSublayerHeader.vue?vue&type=script&lang=js&"
export * from "./AppSublayerHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppSublayerHeader.vue?vue&type=style&index=0&id=ef48a074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef48a074",
  null
  
)

export default component.exports